const Win = ({ title, children }) => (
  <div className="overflow-hidden rounded-lg border border-white/10 bg-[#0a1322] shadow-[0_30px_80px_-30px_rgba(0,0,0,0.8)]">
    <div className="flex items-center justify-between border-b border-white/10 px-4 py-2.5">
      <div className="flex gap-1.5"><span className="h-2 w-2 rounded-full bg-slate-600" /><span className="h-2 w-2 rounded-full bg-slate-600" /><span className="h-2 w-2 rounded-full bg-slate-600" /></div>
      <span className="font-mono text-[11px] text-slate-400">{title}</span>
    </div>
    <div className="p-5 sm:p-6">{children}</div>
  </div>
);

const Pill = ({ c = "slate", children }) => {
  const m = { cyan: "border-cyan-400/30 text-cyan-200", violet: "border-violet-400/30 text-violet-200", green: "border-emerald-400/30 text-emerald-200", amber: "border-amber-400/30 text-amber-200", slate: "border-white/15 text-slate-300" };
  return <span className={`rounded border px-2 py-0.5 font-mono text-[11px] ${m[c]}`}>{children}</span>;
};

const Launch = () => (
  <Win title="mvp-roadmap">
    {[["Accounts & onboarding", "done", "green"], ["Plans & subscriptions", "done", "green"], ["Admin console", "in progress", "cyan"], ["Public launch", "planned", "slate"]].map(([t, s, c]) => (
      <div key={t} className="flex items-center justify-between border-b border-white/5 py-3 last:border-0">
        <span className="text-[14px] text-slate-200">{t}</span><Pill c={c}>{s}</Pill>
      </div>
    ))}
    <div className="mt-4 h-1.5 rounded-full bg-white/10"><div className="grad-line h-full w-3/5 rounded-full" /></div>
  </Win>
);

const Sheets = () => (
  <div className="grid items-center gap-4 sm:grid-cols-[1fr_auto_1fr]">
    <Win title="ops_final_v7.xlsx">
      <div className="grid grid-cols-3 gap-px bg-white/10 font-mono text-[11px]">
        {["#REF!", "Pending", "12/3", "??", "done", "", "dup", "Paid", "#N/A"].map((v, i) => (
          <span key={i} className={`bg-[#0a1322] px-2 py-2 ${v.startsWith("#") || v === "??" || v === "dup" ? "text-rose-300" : "text-slate-400"}`}>{v || "—"}</span>
        ))}
      </div>
    </Win>
    <span className="mx-auto font-mono text-cyan-300">→</span>
    <Win title="orders · structured">
      {[["ORD-1042", "Approved", "green"], ["ORD-1043", "Review", "amber"], ["ORD-1044", "Paid", "cyan"]].map(([o, s, c]) => (
        <div key={o} className="flex items-center justify-between py-2 text-[12px]"><span className="font-mono text-slate-300">{o}</span><Pill c={c}>{s}</Pill></div>
      ))}
    </Win>
  </div>
);

const Apis = () => (
  <Win title="integration-layer.log">
    <div className="grid grid-cols-2 gap-2 sm:grid-cols-4">
      {["Payments", "Messaging", "Accounting", "Logistics"].map((a) => <span key={a} className="rounded border border-white/10 px-2 py-2 text-center text-[12px] text-slate-200">{a}</span>)}
    </div>
    <div className="my-4 flex items-center gap-3"><span className="grad-line h-px flex-1" /><span className="font-mono text-[11px] text-cyan-300">unified API</span><span className="grad-line h-px flex-1" /></div>
    <div className="space-y-1.5 font-mono text-[11.5px]">
      <p className="text-slate-300"><span className="text-emerald-300">200</span> payments.capture  ok</p>
      <p className="text-slate-300"><span className="text-amber-300">503</span> logistics.quote  retry 1/3</p>
      <p className="text-slate-300"><span className="text-emerald-300">200</span> logistics.quote  ok</p>
      <p className="text-slate-300"><span className="text-violet-300">evt</span> webhook.received  queued</p>
    </div>
  </Win>
);

const Automation = () => (
  <Win title="automation-rule">
    {[["WHEN", "An order is approved", "cyan"], ["IF", "Amount exceeds approval limit", "amber"], ["THEN", "Request manager approval", "violet"], ["AND", "Notify customer via email / WhatsApp", "green"]].map(([k, t, c], i) => (
      <div key={k} className="relative flex items-center gap-3 pb-4 last:pb-0">
        {i < 3 && <span className="absolute left-[22px] top-8 h-[calc(100%-24px)] w-px bg-white/10" />}
        <span className="w-12 shrink-0"><Pill c={c}>{k}</Pill></span>
        <span className="flex-1 rounded border border-white/10 bg-white/[0.02] px-3 py-2.5 text-[13px] text-slate-200">{t}</span>
      </div>
    ))}
  </Win>
);

const Portal = () => (
  <Win title="customer-portal">
    <div className="grid grid-cols-[110px_1fr] gap-4">
      <ul className="space-y-1 text-[12px]">
        {["Overview", "Orders", "Invoices", "Support", "Profile"].map((n, i) => <li key={n} className={`rounded px-2 py-1.5 ${i === 1 ? "bg-white/10 text-white" : "text-slate-400"}`}>{n}</li>)}
      </ul>
      <div className="space-y-2">
        <div className="grid grid-cols-2 gap-2">
          <div className="rounded border border-white/10 p-3"><p className="text-[11px] text-slate-400">Open orders</p><p className="mt-1 text-lg font-bold text-white">04</p></div>
          <div className="rounded border border-white/10 p-3"><p className="text-[11px] text-slate-400">Invoices due</p><p className="mt-1 text-lg font-bold text-white">02</p></div>
        </div>
        {["Track shipment", "Download invoice", "Raise a ticket"].map((a) => <div key={a} className="flex justify-between rounded border border-white/10 px-3 py-2 text-[12px] text-slate-300">{a}<span className="text-cyan-300">→</span></div>)}
      </div>
    </div>
  </Win>
);

const Modernize = () => (
  <Win title="modernisation-plan">
    <div className="rounded border border-dashed border-rose-300/30 px-3 py-3 text-center font-mono text-[12px] text-rose-200">legacy_app (tightly coupled)</div>
    <div className="my-3 text-center font-mono text-[12px] text-slate-400">staged migration ↓</div>
    <div className="grid grid-cols-2 gap-2 sm:grid-cols-4">
      {["Auth", "Orders", "Reports", "Public API"].map((m, i) => (
        <span key={m} className="rounded border border-white/10 px-2 py-2.5 text-center text-[12px] text-slate-200">{m}<span className="mt-1 block font-mono text-[10.5px] text-slate-400">stage {i + 1}</span></span>
      ))}
    </div>
  </Win>
);

const MAP = { launch: Launch, sheets: Sheets, apis: Apis, automation: Automation, portal: Portal, modernize: Modernize };

export const SolutionUI = ({ type }) => {
  const C = MAP[type] || Launch;
  return <C />;
};
